import * as React from "react";
import { FormGroupContext } from "./form-group-context";
export function useFormGroup(props) {
    const context = React.useRef();
    if (!context.current) {
        context.current = new FormGroupContext;
    }
    context.current.props = props; // just update it every time
    return context.current;
}
export function extendFormGroupProps(props) {
    // saves a lot of stuffs
    if (props.group) {
        var nextProps = Object.assign({}, props.group.computedChildrenProps);
        // delete nextProps.group;
        // delete nextProps.groupKey;
        for (var i in props) {
            if (i != 'group' && i != 'groupKey') // 
             {
                nextProps[i] = props[i];
            }
        }
        nextProps.value = props.group.value && props.group.value[props.groupKey];
        nextProps.onChange = props.group.getHandleValueProperyChange(props.groupKey);
        return nextProps;
    }
    return props;
}
//# sourceMappingURL=use-form-group.js.map